








import { Component, Vue } from 'vue-property-decorator';
//import HelloWorld from './components/HelloWorld.vue';
import IntraWorkTable from "./components/IntraWorkTable.vue";
//import IntraWorkHeader from "./components/IntraWorkHeader.vue";

@Component({
  components: {
	//HelloWorld,
	IntraWorkTable
    //,IntraWorkHeader
  },
})

export default class App extends Vue {}
